import { authClient } from './amplifyClient';
import {
    getDailyServiceReport,
    getInspectionReport,
    getReport,
    getShiftReport,
} from '../graphql/queries';
import type { ReportSource } from './reportUrlUtils';

const client = authClient;

export const resolveReportSource = async (reportId: string): Promise<ReportSource> => {
    try {
        const inspectionResult = await client.graphql({
            query: getInspectionReport,
            variables: { id: reportId },
        });

        if (inspectionResult.data?.getInspectionReport) {
            return 'InspectionReport';
        }
    } catch {
        // Fall through to next source
    }

    try {
        const dailyServiceResult = await client.graphql({
            query: getDailyServiceReport,
            variables: { id: reportId },
        });

        if (dailyServiceResult.data?.getDailyServiceReport) {
            return 'DailyServiceReport';
        }
    } catch {
        // Fall through to next source
    }

    try {
        const shiftResult = await client.graphql({
            query: getShiftReport,
            variables: { id: reportId },
        });

        if (shiftResult.data?.getShiftReport) {
            return 'ShiftReport';
        }
    } catch {
        // Fall through to next source
    }

    try {
        const legacyResult = await client.graphql({
            query: getReport,
            variables: { id: reportId },
        });

        if (legacyResult.data?.getReport) {
            return 'LegacyReport';
        }
    } catch {
        // Fall through to default
    }

    return 'LegacyReport';
};
